module.exports = __webpack_public_path__ + "static/media/TEACH_white.8ffa59bc.png";